import { Button, Form } from "antd";
import validateMessages from "../../utils/validate";
import Password from "antd/es/input/Password";
import { LockOutlined } from "@ant-design/icons";
import Notification from "../../components/Notification";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../routes";
import { useChangeMyPasswordMutation } from "../../services/me";
import { useTranslation } from "react-i18next";

const ChangePassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [passwordForm] = Form.useForm();
    const password = Form.useWatch("newPassword", passwordForm);

    const validateConfirmPassword = (rule: any, value: string) => {
        if (value && password) {
            if (value === password) {
                return Promise.resolve();
            }
            return Promise.reject(new Error(t("Passwords don't match")));
        }
        return Promise.resolve();
    };
    const [changePassword, changePasswordResult] = useChangeMyPasswordMutation();

    const handleChangePassword = async () => {
        try {
            await passwordForm.validateFields();
        } catch (errorInfo) {
            return;
        }

        const formFields = passwordForm.getFieldsValue();
        const payload = {
            currentPassword: formFields.currentPassword,
            newPassword: formFields.newPassword
        };
        try {
            await changePassword(payload).unwrap();
            Notification({
                type: "success",
                title: t("Password"),
                description: t("Password changed successfully"),
                placement: "top"
            });
            navigate(ROUTES.PATHS.PROFILE);
        } catch (e) { }
    };
    const requiredRule = { required: true, message: t("Required") };

    return (
        <div style={{ maxWidth: "400px" }}>
            <Form
                form={passwordForm}
                layout="vertical"
                name="passwordForm"
                validateMessages={validateMessages}
            >
                <div className="mb-5">
                    <Form.Item name="currentPassword" label={<>{t("Current password")}<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
                        <Password size="large" prefix={<LockOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
                    </Form.Item>
                    <Form.Item name="newPassword" label={<>{t("New password")}<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule, { validator: validateConfirmPassword }]}>
                        <Password size="large" prefix={<LockOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
                    </Form.Item>
                    <Form.Item name="confirmPassword" label={<>{t("Confirm password")}<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule, { validator: validateConfirmPassword }]}>
                        <Password size="large" prefix={<LockOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
                    </Form.Item>
                    <Button onClick={handleChangePassword} type="primary" block size="large">
                        {t(changePasswordResult.isLoading ? "Please wait..." : "Change Password")}
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default ChangePassword;
